import React from 'react';
import { cn } from '@/lib/utils';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  className?: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  title = 'Failed to load data',
  message = 'An error occurred while communicating with the backend API.',
  onRetry,
  className,
}) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center p-8 text-center rounded-lg border border-rose-900/40 bg-rose-950/20 animate-scale-in',
        className
      )}
    >
      <div className="p-3 rounded-full bg-rose-950/60 border border-rose-800/60 text-rose-400 mb-3 shadow-[0_0_15px_rgba(244,63,94,0.15)]">
        <AlertTriangle className="w-6 h-6 stroke-[1.5]" />
      </div>
      <h4 className="text-sm font-semibold text-rose-200 mb-1 font-sans">{title}</h4>
      <p className="text-xs text-rose-300/70 max-w-sm mb-4 font-mono">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-md bg-rose-950/80 hover:bg-rose-900/90 active:scale-95 border border-rose-800/80 text-rose-200 text-xs font-mono font-medium transition-all duration-150"
        >
          <RefreshCw className="w-3.5 h-3.5" />
          <span>Retry Request</span>
        </button>
      )}
    </div>
  );
};
